'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

var $header = $('.header'),
	$scrollHeader = $('.header.scroll'),
	$headerTop = $('.header__top'),
	$wrapper = $('.wrapper'),
	$searchWrap = $('.header__search-wrap'),
	$searchBox = $('.header__search-hidden'),
	$searchButton = $('.header__search-btn'),
	$dropdown = $('.header__top-dropdown'),
	$dropdownBtn = $('.header__top-dropdown-btn'),
	$dropdownIcon = $('.header__lang-icon'),
	$dropdownWrap = $('.header__top-dropdown-wrap'),
	$headerSearchInput = $('.header__search-input');

// function toggleContent () {
// 	// $hide.removeClass('show');
// 	// $show.addClass('show');
//
// 	$('body').on('click', '.remind-password-toggle', function () {
// 		$('.login').removeClass('show');
// 		$('.remind-password').addClass('show');
// 	});
// }

// ----------------------------------------
// Public
// ----------------------------------------

function fixedHeader () {
	if ($(window).scrollTop() > 40 && !$scrollHeader.length) {
		$headerTop.slideUp('slow');
		$header.addClass('scroll');
	}

	if ($(window).scrollTop() === 0) {
		$headerTop.slideDown('fast');
		$header.removeClass('scroll');
	}
}

function headerSearch () {
	$searchButton.on('click', function () {
		if ($searchBox.hasClass('open')) {
			$searchBox.children('.js-form')[0].reset();
		}

		$(this).toggleClass('active');
		$searchWrap.toggleClass('open');
		$searchBox.toggleClass('open');
	});

	$('.header__search-input').keypress(function (event) {
		if (event.which === 13) {
			event.preventDefault();
			$(this).closest('.js-form').submit();
		}
	});

	$(document).click(function (e) {
		if (!$searchWrap.is(e.target) && $searchWrap.has(e.target).length === 0) {
			$searchBox.removeClass('open');
			$searchWrap.removeClass('open');
			$searchButton.removeClass('active');

			$searchBox.children('.js-form')[0].reset();
		}
	});
}

function setPaddingTop () {
	const $header = $('.header');
	const headerHeight = $header.outerHeight();

	$wrapper.css({'padding-top': headerHeight});
	$('.moonlight-top').css('height', headerHeight);

	// $('#textbox1').val(this.checked);

	$('#checkbox1').change(function () {
		if (this.checked) {
			console.log('checked');
		} else {
			console.log('unchecked');
		}
	});
}

function headerLang () {
	$dropdownBtn.on('click', function () {
		$dropdownWrap.toggleClass('open');
		$dropdown.slideToggle('fast');
		$dropdownIcon.toggleClass('open');
	});

	$(document).click(function (e) {
		if (!$dropdownWrap.is(e.target) && $dropdownWrap.has(e.target).length === 0) {
			$dropdown.slideUp('fast');
			$dropdownIcon.removeClass('open');
			$dropdownWrap.removeClass('open');
		}
	});
}

function loginToggle () {
	let $body = $('body');

	$body.on('click', '.remember-password', function () {
		$('.login-wrap').removeClass('show');
		$('.remember-wrap').addClass('show');
	});

	$body.on('click', '.login', function () {
		$('.remember-wrap').removeClass('show');
		$('.login-wrap').addClass('show');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {fixedHeader, headerSearch, setPaddingTop, headerLang, loginToggle};



// WEBPACK FOOTER //
// ./src/js/_modules/header.js